import React from 'react'
import { Button, Badge } from 'react-bootstrap'
import {
  getLabelFromValue,
  getCurrencyLabel,
  calculateCommissionValue,
  isGreaterThanZero,
  numberWithCommas,
} from '../../../../../helpers'
import { defaultBookingStatus } from '../../../../../constants'

const SERVICE_ICONS = {
  departure: '/images/Flight_departure.png',
  transit: '/images/flight_transit.png',
  arrival: '/images/flight_arrival.png',
}

const VIPChatQuoteCard = ({
  quote,
  messageId,
  history,
  messageInfoNode,
  openCommissionModal,
}) => {
  const { query = {}, searchResults = [] } = quote

  const serviceType = query.serviceType || 'arrival'
  const serviceLabel =
    query.serviceLabel ||
    serviceType.charAt(0).toUpperCase() + serviceType.slice(1)
  const iconSrc = SERVICE_ICONS[serviceType] || SERVICE_ICONS.arrival

  return searchResults.map((result, index) => {
    const cur = getCurrencyLabel(result.currency)
    const passengers = result.passengers || {
      adults: query.adults || 1,
      children: query.children || 0,
      infants: query.infants || 0,
    }
    const totalPax =
      (passengers.adults || 0) +
      (passengers.children || 0) +
      (passengers.infants || 0)
    const luggageCount = result.luggage || query.luggage || 0
    const price = result.rate != null ? Number(result.rate).toFixed(2) : '—'
    const bookingId = result.bookingId || (result.booking && result.booking.id)
    const booking = result.booking || null
    const status = result.status || null
    const benefits = result.benefits || null
    const actualRate = result.actualRate || null
    const clientMarkupRate = result.clientMarkupRate || null
    const salesTaxAmount = result.salesTaxAmount || null
    const salesTaxRate = result.salesTaxRate || null

    const hasCommission =
      openCommissionModal &&
      benefits != null &&
      actualRate != null &&
      (isGreaterThanZero(actualRate, benefits.commissionWeight) ||
        isGreaterThanZero(actualRate, benefits.discountWeight))

    const handleInfoClick = () => {
      if (!openCommissionModal || !hasCommission) return
      openCommissionModal(
        isGreaterThanZero(actualRate, benefits.commissionWeight)
          ? numberWithCommas(
              calculateCommissionValue(
                actualRate,
                benefits.commissionWeight,
                benefits.discountWeight || 0
              ).toFixed(2)
            )
          : null,
        isGreaterThanZero(actualRate, benefits.commissionWeight)
          ? benefits.commissionWeight
          : null,
        isGreaterThanZero(actualRate, benefits.discountWeight)
          ? numberWithCommas(
              parseFloat((actualRate * benefits.discountWeight) / 100).toFixed(
                2
              )
            )
          : null,
        isGreaterThanZero(actualRate, benefits.discountWeight)
          ? { weight: benefits.discountWeight, code: benefits.code }
          : null,
        result.rate != null ? result.rate : 0,
        salesTaxAmount,
        salesTaxRate,
        cur,
        clientMarkupRate,
        'VIP Meet & Greet'
      )
    }

    const isExpired =
      !booking &&
      (status === 'quote_expired' ||
        status === 'cancellation_accepted_by_agent' ||
        status === 'unavailable')

    const isPaid = booking && booking.status && booking.status !== 'quote'

    const handleCardClick =
      isPaid && bookingId
        ? () => history.push(`/booking/my-bookings/details/${bookingId}`)
        : undefined

    return (
      <div key={`vip-card-${index}`} className='vip-chat-quote-card__wrapper'>
        {/* ── Card — clickable when booked ── */}
        <div
          className={`vip-chat-quote-card client-chat${
            isPaid && bookingId ? ' vip-chat-quote-card--clickable' : ''
          }`}
          onClick={handleCardClick}
        >
          <div className='vip-chat-quote-card__top'>
            <div className='d-flex justify-content-between w-100'>
              <img
                src={iconSrc}
                alt={serviceType}
                className='vip-chat-quote-card__icon'
              />
              <div className='vip-chat-quote-card__pax'>
                {totalPax > 0 && (
                  <span>
                    <img src='/images/icons/team.svg' alt='pax' /> {totalPax}
                  </span>
                )}
                {luggageCount > 0 && (
                  <span>
                    <img src='/images/icons/portfolio.svg' alt='luggage' />{' '}
                    {luggageCount}
                  </span>
                )}
              </div>
            </div>
            <div className='vip-chat-quote-card__info'>
              <div className='d-flex flex-column'>
                <span className='vip-chat-quote-card__type'>
                  {serviceLabel.toUpperCase()}
                </span>
                <span className='vip-chat-quote-card__title'>
                  VIP Meet and Greet
                </span>
              </div>
              <span className='vip-chat-quote-card__price'>
                {price} {cur}
                {hasCommission && (
                  <img
                    alt=''
                    className='info-icon ml-1'
                    src='/images/icons/icon-information.png'
                    onClick={e => {
                      e.stopPropagation()
                      handleInfoClick()
                    }}
                  />
                )}
              </span>
            </div>
          </div>
        </div>

        {/* ── Status badge ── */}
        {((booking && booking.status) || isExpired) && (
          <div className='vip-chat-quote-card__footer'>
            <Badge
              href='#'
              variant={
                isExpired && status
                  ? `${status} badge-outlined badge-outlined-none`
                  : `${booking.status} badge-outlined badge-outlined-none`
              }
              style={{ textTransform: 'uppercase' }}
            >
              {getLabelFromValue(
                defaultBookingStatus,
                isExpired && status ? status : booking.status
              )}
            </Badge>
          </div>
        )}

        {/* ── Timestamp + Book button row ── */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>{messageInfoNode}</div>

          {/* Book button (quote not yet booked) */}
          {!booking && !bookingId && !isExpired && (
            <div className='vip-chat-quote-card__footer vip-chat-quote-card__footer--action'>
              <Button
                className='book-btn'
                variant='brown'
                type='button'
                onClick={() =>
                  history.push({
                    pathname: `/booking/quotes/vip-meet-greet/${messageId}/${index}`,
                    messageId,
                  })
                }
              >
                Book
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  })
}

export default VIPChatQuoteCard
